export interface Score {
  raw: number | '';
  max: number | '';
  min: number | '';
  scaled: number | '';
}

export function defaultScore(): Score {
  return {
    min: '',
    max: '',
    raw: '',
    scaled: ''
  };
}
